import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import TopBar from "../website/TopBar";
import Hero from "../website/Hero";
import AnimateGallery from "./components/AnimateGallery";
import RainbowButton from "../website/RainbowButton";
import CursorEffect from "../../ui/components/CursorEffect";
import Footer from "../website/Footer";
import GlobalMessage from "../pricing/GlobalMessage";

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100svh;
    background-color: ${Colors.background};
    color: ${Colors.black};
    padding: 5px 5px 0 5px;
    gap: 10px;
    overflow-x: visible;
    overflow-y: auto;
`;

const InitialContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    text-align: center;
    margin: 0;
    margin-bottom: 40px;
    gap: 20px;
    overflow: visible;
`;

const InitialButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 10px;
    margin-top: 30px;
    gap: 10px;
    z-index: 2;

    @media (max-width: 412px) {
        flex-direction: column;
        width: 100%;
        gap: 20px;
    }
`;

interface AnimateInitialProps {
    config: any;
    onCreateClick: () => void;
}

const AnimateInitial = ({ config, onCreateClick }: AnimateInitialProps) => {
    
    const primaryButtons = (
        <InitialButtonContainer>
            <RainbowButton 
                color='black' 
                text="New Animation" 
                onClick={onCreateClick} 
            />
        </InitialButtonContainer>
    );

    const tabs = [
        { name: 'My Animations' },
        { name: 'Community' },
    ];

    return (
        <Root id="animate-initial-root">
            <GlobalMessage config={config} colorMode="light" />
            <TopBar type={'Animate'} colorMode='light'/> 
            <InitialContainer>
                <Hero 
                    title="AI Animator" 
                    subtitle="Create game-ready sprite sheets in any art style." 
                    subtitleSize="small"
                    colorMode='light'
                    children={primaryButtons} 
                />
                <AnimateGallery colormode="light" tabs={tabs} />
                <CursorEffect colorMode="light"/>
            </InitialContainer>
            <Footer colorMode='light'/>
        </Root>
    );
};

export default AnimateInitial;